<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'AdminLayout'
}
</script>

<style scoped>

</style>